import React from "react";
import { useAVToggle } from "@100mslive/react-sdk";
import { Button, Flex, styled } from "@100mslive/roomkit-react";
import { useLanguage } from "../../context/LanguageContext";
import { ScreeningContext } from "../../context/ScreeningContext";
import { getTranslation } from "../../locales";

const PreviewName = ({ name, onChange, onJoin, enableJoin }) => {
  const { isLocalVideoEnabled, isLocalAudioEnabled } = useAVToggle();
  const { screeningData } = React.useContext(ScreeningContext);
  const { currentLanguage } = useLanguage();
  const t = getTranslation(currentLanguage);
  const formSubmit = e => {
    e.preventDefault();
  };
  return (
    <Form css={{ width: "auto", position: "relative" }} onSubmit={formSubmit}>
      <Flex direction="column">
        {enableJoin && isLocalAudioEnabled && isLocalVideoEnabled ? (
          <Button
            type="submit"
            disabled={!enableJoin}
            onClick={onJoin}
            css={{
              w: "300px",
              h: "48px",
              fontSize: "$sm",
              fontWeight: "400",
              fontFamily: "Nunito",
            }}
          >
            {screeningData.questionIndex == 0
              ? t.previewScreen.previewName.startInterview
              : t.previewScreen.previewName.nextQuestion}
          </Button>
        ) : (
          <Button
            disabled={true}
            css={{
              w: "300px",
              h: "48px",
              fontSize: "$sm",
              fontWeight: "$semiBold",
              wordBreak: "break-word",
              overflowWrap: "break-word",
              bg: "#5186ED!important",
              opacity: "0.5",
              fontWeight: "400",
              fontFamily: "Nunito",
            }}
          >
            {t.previewScreen.previewName.startInterview}
          </Button>
        )}
        <a
          target="_blank"
          href={screeningData.screeningUrl}
          style={{
            border: "2px solid #A6A8AC",
            borderRadius: "0.5rem",
            width: "100%",
            flexDirection: "column",
            height: "auto",
            textDecoration: "none",
            color: "#A6A8AC",
            height: "48px",
            textAlign: "center",
            alignContent: "center",
            fontSize: "0.875rem",
            marginTop: "24px",
          }}
          rel="noreferrer"
        >
          {t.previewScreen.previewName.scheduleInterview}
        </a>
      </Flex>
    </Form>
  );
};

const Form = styled("form", {
  width: "100%",
  display: "flex",
  alignItems: "center",
});

export default PreviewName;
